var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.515 2.27a1 1 0 01.97 0l8 4.444a1 1 0 01.515.874V10a1 1 0 01-.898.995L20 11v6l.102.005A1 1 0 0121 18v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 01.897-.995L4 17v-6l-.103-.005A1 1 0 013 10V7.588a1 1 0 01.515-.874l8-4.444zM14 11v6h2v-6h-2zm-6 6h2v-6H8v6z",
    fill: "currentColor"
  })));
}
SvgBankFilled.displayName = 'BankFilled';
export default SvgBankFilled;